import TableCell from "../common/ui/TableCell";

export default function MaterialGIView({ data }) {
  const header = data.header || {};
  const items = (data?.lines || []).map((r) => ({
    ...r.body,
  }));

  const fmt = (v) =>
    v === undefined || v === null || v === "" ? "" : Number(v).toLocaleString();

  const fmtDate = (v) => {
    const d = new Date(v);
    return isNaN(d) ? "-" : d.toLocaleDateString();
  };

  const columns = [
    { key: "code", label: "품목 코드" },
    { key: "name", label: "품명" },
    { key: "spec", label: "규격" },
    { key: "unit", label: "단위", align: "center" },
    { key: "qty", label: "출고 수량", align: "right" },
    { key: "remark", label: "비고" },
  ];

  return (
    <div className="space-y-6">
      {/* ===============================
          Header Info
      =============================== */}
      <table className="doc-table w-full text-sm">
        <tbody>
          <tr>
            <TableCell label="출고번호" value={header.issue_no || "-"} />
            <TableCell label="출고일" value={fmtDate(header.issue_date)} />
          </tr>
          <tr>
            <TableCell label="수령자" value={header.receiver || "-"} />
            <TableCell label="창고" value={header.warehouse || "-"} />
          </tr>
        </tbody>
      </table>

      {/* ===============================
          Item Table
      =============================== */}
      <table className="doc-table w-full text-sm mt-4">
        <thead className="doc-thead">
          <tr>
            {columns.map((c, idx) => (
              <th
                key={c.key}
                className={idx === columns.length - 1 ? "doc-th-end" : "doc-th"}
                style={{
                  textAlign:
                    c.align === "right"
                      ? "right"
                      : c.align === "center"
                      ? "center"
                      : "left",
                }}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {items.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="doc-td text-center text-gray-400 py-4"
              >
                항목이 없습니다.
              </td>
            </tr>
          ) : (
            items.map((row, idx) => (
              <tr key={idx}>
                {columns.map((c) => (
                  <td
                    key={c.key}
                    className={`doc-td ${
                      c.align === "right"
                        ? "text-right"
                        : c.align === "center"
                        ? "text-center"
                        : ""
                    }`}
                  >
                    {c.key === "qty" ? fmt(row[c.key]) : row[c.key] ?? ""}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
